import { ConfiguratorRequest } from 'components/ordering/configurator/api/configurator-request.js'
import {
  parseStepSelectionDataRecord,
  StepSelectionData
} from 'components/ordering/configurator/api/dtos/step-selection-data.js'

type GetPayloadParams = {
  productSlug: string
  productId: number
  payload?: string | undefined
}

export class GetPayload extends ConfiguratorRequest<Record<string, StepSelectionData>, never> {
  path: string

  constructor({ productSlug, productId, payload }: GetPayloadParams) {
    super()

    const params = new URLSearchParams()
    if (payload) params.set('payload', payload)

    const query = params.toString()
    this.path = `p/${productSlug}/${productId}/configurator/payload/${query ? `?${query}` : ''}`
  }

  override parseResponse = parseStepSelectionDataRecord
}
